import {
  Checkbox,
  Chip,
  Table,
  TableBody,
  TableHead,
  TableRow,
} from '@mui/material';

import {
  CustomTextField,
  DrawerFormSection,
  GeneralTableBox,
  HeadTableCell,
  RowTableCell,
} from '../../../../common/components';
import { formatCurrencyAmount, parseNumber } from '../../utils/supplierLedgerFormatters';
import PaymentOrderProviderHeader from './PaymentOrderProviderHeader';

const PaymentOrderInvoicesSection = ({ controller }) => {
  const {
    activeProvider,
    activeProviderOrderGroups,
    applications,
    handleApplicationChange,
    handleToggleInvoice,
    includedInvoices,
  } = controller;

  return (
    <>
      <PaymentOrderProviderHeader controller={controller} />
      <DrawerFormSection
        title="Facturas incluidas"
        action={activeProviderOrderGroups.length > 1 && (
          <Chip size="small" color="warning" label={`${activeProviderOrderGroups.length} OP por moneda`} />
        )}
        grid={false}
      >
        <GeneralTableBox
          hasMaxHeight={false}
          sx={{
            backgroundColor: 'background.paper',
            border: '1px solid',
            borderColor: 'divider',
            minHeight: 'auto',
            overflowX: 'hidden',
            '& table': {
              tableLayout: 'fixed',
              width: '100%',
              minWidth: 0,
            },
            '& th, & td': {
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
              px: 1,
            },
          }}
        >
          <Table size="small">
            <TableHead>
              <TableRow>
                <HeadTableCell padding="checkbox" sx={{ width: 44 }} />
                <HeadTableCell sx={{ width: 142 }}>Factura</HeadTableCell>
                <HeadTableCell>Concepto</HeadTableCell>
                <HeadTableCell align="right" sx={{ width: 138, textAlign: 'right' }}>Pendiente</HeadTableCell>
                <HeadTableCell align="right" sx={{ width: 132, textAlign: 'right' }}>A pagar</HeadTableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {(activeProvider?.invoices || []).map((invoice) => {
                const included = Boolean(includedInvoices[invoice.uuid]);
                const applied = parseNumber(applications[invoice.uuid] || 0);
                const pending = Number(invoice.pending_amount || 0);
                const invalid = included && (applied <= 0 || applied > pending);
                return (
                  <TableRow key={invoice.uuid} sx={{ opacity: included ? 1 : 0.58 }}>
                    <RowTableCell padding="checkbox" sx={{ width: 44 }}>
                      <Checkbox
                        checked={included}
                        onChange={(event) => handleToggleInvoice(invoice.uuid, event.target.checked)}
                      />
                    </RowTableCell>
                    <RowTableCell sx={{ width: 142, fontWeight: 700 }} title={`${invoice.receipt_type} ${invoice.receipt_number}`}>
                      {invoice.receipt_type} {invoice.receipt_number}
                    </RowTableCell>
                    <RowTableCell title={invoice.concept_summary || '-'}>
                      {invoice.concept_summary || '-'}
                    </RowTableCell>
                    <RowTableCell align="right" sx={{ width: 138, textAlign: 'right' }}>
                      {formatCurrencyAmount(invoice.pending_amount, invoice.currency)}
                    </RowTableCell>
                    <RowTableCell align="right" sx={{ width: 132, textAlign: 'right', py: 1 }}>
                      <CustomTextField
                        name={`application-${invoice.uuid}`}
                        value={applications[invoice.uuid] || ''}
                        onChange={(event) => handleApplicationChange(invoice.uuid, event.target.value)}
                        error={invalid}
                        disabled={!included}
                        size="small"
                        placeholder="0,00"
                        sx={{ width: 116, ml: 'auto', mt: 0 }}
                      />
                    </RowTableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </GeneralTableBox>
      </DrawerFormSection>
    </>
  );
};

export default PaymentOrderInvoicesSection;
